
import { ButtonComponent } from '@caresend/ui-components';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BookingBackButton',
  components: { ButtonComponent },
});
